import { Route, Routes } from "react-router-dom";
import { routerType } from "../types/route.types";
import pagesData from "./pagesData";
import React from "react";

const Router = () => {
  const pageRoutes = pagesData.map(({ path, title, element }: routerType) => {
    return <Route key={title} path={`/${path}`} element={element} />;
  });

  return <Routes>{pageRoutes}</Routes>;
};

export default Router;
